import { isFunction, throttle } from 'lodash'
/* 吸顶方法 */
// marginTop 防止fixed时抖动  buffer时跟着表体滚动而滚动
export default function createSticky ({ fixEl, referEl, offetTop = 0, scrollFn, clearFixFn, buffer = 50, warpEl }) {
  const height = fixEl.getBoundingClientRect().height
  let handleScroll = () => {
    const { bottom, top } = referEl.getBoundingClientRect()
    if (height + buffer >= bottom) {
      fixEl.style.top = bottom - height - buffer + 'px'
      if (isFunction(clearFixFn)) { clearFixFn({ fixEl }) }
      return
    }
    if (top > 0) {
      fixEl.style.position = ''
      fixEl.style.top = ''
      fixEl.style.zIndex = 'auto'
      warpEl && (warpEl.style.marginTop = 0)
    } else {
      fixEl.style.position = 'fixed'
      fixEl.style.top = offetTop + 'px'
      fixEl.style.zIndex = 2001
      warpEl && (warpEl.style.marginTop = height + 'px')
    }
    if (isFunction(scrollFn)) {
      scrollFn({ isFixed: top <= 0, height, fixEl })
    }
  }
  handleScroll = throttle(handleScroll, 100)
  window.addEventListener('scroll', handleScroll)
  return () => { window.removeEventListener('scroll', handleScroll) }
}